import Immutable from 'immutable';
const LOAD = 'bitewingReport/LOAD';
const LOAD_FAIL = 'bitewingReport/LOAD_FAIL';
const CLOSE_ERROR_MESSAGE = 'bitewingReport/CLOSE_ERROR_MESSAGE';
const LOAD_BITEWING_REPORT_SUCCESS = 'bitewingReport/LOAD_BITEWING_REPORT_SUCCESS';
const LOAD_BITEWING_REPORT_DETAILS_SUCCESS = 'bitewingReport/LOAD_BITEWING_REPORT_DETAILS_SUCCESS';
const LOAD_BITEWING_REPORT_FAIL = 'bitewingReport/LOAD_BITEWING_REPORT_FAIL';
const LOAD_BITEWING_REPORT_DETAILS_FAIL = 'bitewingReport/LOAD_BITEWING_REPORT_DETAILS_FAIL';

const initialState = Immutable.fromJS({
  isLoad: false,
  loadErr: null,
  bitewingReportList:{},
  bitewingReportDetails: {}
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LOAD:
      return state
        .set('isLoad', true)
        .set('loadErr', null);

    case LOAD_FAIL:
      return state
        .set('isLoad', false)
        .set('loadErr', null);

    case CLOSE_ERROR_MESSAGE:
      return state
        .set('loadErr', null);

    case LOAD_BITEWING_REPORT_SUCCESS:
      return state
        .set('isLoad', false)
        .set('loadErr', null)
        .set('bitewingReportList', action.res);

    case LOAD_BITEWING_REPORT_FAIL:
      return state
        .set('isLoad', false)
        .set('loadErr', action.error)
        .set('bitewingReportList', {});

    case LOAD_BITEWING_REPORT_DETAILS_SUCCESS:
      return state
        .set('isLoad', false)
        .set('loadErr', null)
        .set('bitewingReportDetails', action.res);

    case LOAD_BITEWING_REPORT_DETAILS_FAIL:
      return state
        .set('isLoad', false)
        .set('loadErr', action.error)
        .set('bitewingReportDetails', {});

    default:
      return state;
  }
};

export const hideErrorModal = () => async (dispatch, getState, api) => {
  dispatch({ type: CLOSE_ERROR_MESSAGE, action: null });
}

export const getBitewingReports = (params='') => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    let res = await api.get(`reports/api/bitewingReport/${params}`);
    dispatch({ type: LOAD_BITEWING_REPORT_SUCCESS, res: res });
    return res;
  } catch (err) {
    dispatch({ type: LOAD_BITEWING_REPORT_FAIL, error: err.message });
    return false;
  }
};

export const getBitewingDetailsReports = (params='') => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    let res = await api.get(`reports/api/bitewingDetailsReport/${params}`);
    dispatch({ type: LOAD_BITEWING_REPORT_DETAILS_SUCCESS, res: res });
    return res;
  } catch (err) {
    dispatch({ type: LOAD_BITEWING_REPORT_DETAILS_FAIL, error: err.message });
    return false;
  }
};

export const sendReport = (reportObj) => async (dispatch, getState, api) => {
  try {
    let res = await api.post('reports/api/sendBitewingReport', {data:reportObj});
    return res;
  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
  }
};
